import getDensityOptionState from '../store/store';
import { mutator } from 'satcheljs';
import { displayDensityOptionSelected } from '../actions/internalActions';

mutator(displayDensityOptionSelected, actionMessage => {
    const densityOption = getDensityOptionState();
    densityOption.densityModeSelected = actionMessage.newDensityModeSelected;
});
